import { useMutation } from '@apollo/client';
import { graphql } from '../graphql';
import { RECEIVE_EVENTS } from './useReceiveEvents';
export const SEND_MESSAGE = graphql(`
  mutation SendMessage($id: String!, $message: String!, $timestamp: String!) {
    sendMessage(input: { id: $id, message: $message, timestamp: $timestamp })
  }
`);
export const useSendMessage = () => {
    const [sendMessage] = useMutation(SEND_MESSAGE);
    return ({ message, timestamp, id, }) => sendMessage({
        variables: {
            id,
            message,
            timestamp,
        },
        refetchQueries: [{ query: RECEIVE_EVENTS }],
    }).then(response => { var _a; return (_a = response.data) === null || _a === void 0 ? void 0 : _a.sendMessage; });
};
//# sourceMappingURL=useSendMessage.js.map